var data = {
	"body": "<g fill=\"none\"><path d=\"M20 20L4 4m16 0L4 20\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\"/></g>",
	"width": 24,
	"height": 24
};
export default data;
